import norema from './norema'

export default { ...norema }
